/* import __COLOCATED_TEMPLATE__ from './top-banner.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();